import { Collapse, Stack, SxProps, Theme } from '@mui/material';
import { SystemStyleObject } from '@mui/system';
import { createContext, FC, PropsWithChildren, ReactNode, useState } from 'react';

export interface ListAccordionContextValue {
  expanded: boolean;
  toggle: () => void;
}

export const ListAccordionContext = createContext<ListAccordionContextValue>({
  expanded: true,
  toggle: () => {},
});

export interface ListAccordionProps {
  header: ReactNode;
  defaultExpanded?: boolean;
  sx?: SxProps<Theme>;
}

export const ListAccordion: FC<PropsWithChildren<ListAccordionProps>> = ({
  header,
  defaultExpanded = true,
  children,
  sx,
}) => {
  const [expanded, setExpanded] = useState(defaultExpanded);

  return (
    <Stack
      data-scope
      sx={(theme) => ({
        border: (theme) => `1px solid ${theme.palette.common.light2}`,
        borderRadius: 1,
        overflow: 'hidden',
        ...((typeof sx === 'function' ? sx(theme) : sx) as SystemStyleObject),
      })}
    >
      <ListAccordionContext.Provider value={{ expanded, toggle: () => setExpanded((v) => !v) }}>
        {header}
      </ListAccordionContext.Provider>
      <Collapse in={expanded}>{children}</Collapse>
    </Stack>
  );
};
